module.exports = __webpack_public_path__ + "img/img_08.4522021b.jpg";